import * as React from "react"
import { HeadingName, EventCardProps, renderBetButtonsAmerican } from "../../../../components";
import { pickLiveOrPreliveId, prepareEmptyMarket, mapMarketName } from "../../../../../../helpers";

export const renderMarketsAmerican = (cardProps: EventCardProps, buttonsHolderClass: string, componentPrefix: string) => {
    let marketsInConfig = cardProps.sport.config.markets;

    return (
        <div key={`${componentPrefix}__buttons-holder__${cardProps.event.id}`} className={`rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`} data-uat={`div-ev-list-${componentPrefix}-buttons-holder`}>
            {marketsInConfig.map(
                (m, index) => {
                    let market = cardProps.markets.find(market => market.marketType.id === pickLiveOrPreliveId(m, cardProps.event.isLive));
                    let emptyMarket = prepareEmptyMarket(cardProps, m.template, index);

                    return !cardProps.isDesktop
                        ? <div key={`${componentPrefix}__section-wrap__${cardProps.event.id}-${index}`}className={`rj-ev-list__${componentPrefix}__section-wrap`} data-uat={`div-ev-list-${componentPrefix}-section-wrap`}>
                                <HeadingName name={mapMarketName(m, cardProps.dict, cardProps.event.sportId)[0]} />
                                {renderBetButtonsAmerican(market || emptyMarket, cardProps.handlers.betButton, componentPrefix, cardProps.event.isTeamSwap, cardProps.dict, cardProps.isDesktop)}
                            </div>
                        : renderBetButtonsAmerican(market || emptyMarket, cardProps.handlers.betButton, componentPrefix, cardProps.event.isTeamSwap, cardProps.dict, cardProps.isDesktop)
                    }
            )}
        </div>
    )
}